import * as React from 'react';
import { MatchPlayerFragment } from '../../../generated/graphql';
import { PlayerAvatar } from '../../../components/PlayerAvatar';
import { InternalLink } from '../../../components/InternalLink';
import { paths } from '../../../paths';

interface Props {
  player: Pick<MatchPlayerFragment, 'id' | 'name' | 'isArchived'>;
  linkToPlayer?: boolean;
}

export const PlayerNameWithAvatar: React.FC<Props> = ({
  player,
  linkToPlayer = false,
}) => {
  const playerContent = (
    <>
      <PlayerAvatar player={player} className="mr-2 flex-shrink-0" />
      {player.name}{' '}
      {player.isArchived ? (
        <span title="Player is archived" className="ml-2">
          📦
        </span>
      ) : null}
    </>
  );

  const wrapperClass = `flex items-center text-left ${
    player.isArchived ? 'opacity-70' : ''
  }`;

  return linkToPlayer ? (
    <InternalLink
      to={paths.player.home(player.id)}
      className={`${wrapperClass} hover:text-grey-600 text-left`}
    >
      {playerContent}
    </InternalLink>
  ) : (
    <div className={wrapperClass}>{playerContent}</div>
  );
};
